/**
 * @generated SignedSource<<766f53b7c7a6797ae0a57d52493a634d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "updatePrivacySubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserConsents",
        "kind": "LinkedField",
        "name": "consents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receive_service_updates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receive_event_invites",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receive_polling",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivacyFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrivacyFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5bf008a3ce2c8ac5af91250f4107588d",
    "id": null,
    "metadata": {},
    "name": "PrivacyFormMutation",
    "operationKind": "mutation",
    "text": "mutation PrivacyFormMutation(\n  $input: UpdatePrivacySubscriptionInput!\n) {\n  updatePrivacySubscription(input: $input) {\n    id\n    consents {\n      receive_service_updates\n      receive_event_invites\n      receive_polling\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6afd706c813ad28baba767d1c24bf74b";

module.exports = node;
